<script setup>
import { computed } from 'vue'

const staffCount = computed(() => {
    return window.prebook.staffs
})
</script>
<template>
    <div class="staff-loader">
        <!-- loader item -->
        <div v-for="i in staffCount" class="staff-loader__item">
            <div class="staff-loader__item-image"></div>
            <div class="staff-loader__item-content">
                <div class="staff-loader__item-content-title"></div>
                <div class="staff-loader__item-content-subtitle"></div>
            </div>
        </div>
    </div>
</template>